import { BaseInput } from "shared/components/forms/BaseInput";

export const AddressPreview = ({
  value,
  onChange
}: {
  value: string;
  onChange: (value: string) => void;
}) => {
  return (
    <BaseInput
      id="preview-address"
      label="Address"
      hideOptional
      value={value}
      onChange={onChange}
      placeholder="Enter address..."
    />
  );
};
